module.exports = __webpack_public_path__ + "static/media/travel11.7e7bc036.jpg";